import { Expose } from "class-transformer";

export class CreateClientPaymentMethodDto {
  @Expose()
  name: string;
}
